import classNames from 'classnames';
import React from 'react';

import getCurrencyString from '../../helpers/getCurrencyString';
import './OfferCardStyle.less';

export interface IProps {
  feeLabel?: string;
  feePct?: number;
  headlineCents: number;
  netCents: number;
  highlightText?: string;
  isFocused?: boolean;
  onClick?: () => void;
  primary?: boolean;
  title?: string;
}

const OfferCard: React.SFC<IProps> = props => {
  return (
    <div
      className={classNames({
        'od-offer-card': true,
        'od-offer-card--clickable': !!props.onClick,
        'od-offer-card--focused': props.isFocused,
      })}
      onClick={props.onClick}
    >
      {props.highlightText && (
        <div className="od-offer-card__highlight text-bold text-center">{props.highlightText}</div>
      )}
      <div className="od-offer-card__contents">
        <div className="od-offer-card__header">
          <div
            className={classNames({
              'text-blue': props.primary,
              'text-bold': true,
            })}
          >
            {props.title}
          </div>
          <h3>{getCurrencyString(props.headlineCents)}</h3>
          {props.feePct && (
            <div className="od-offer-card__fee text-center">
              {props.feeLabel}
              &nbsp;
              <b>
                {parseFloat((props.feePct * 100).toFixed(2))}
                %&nbsp;
                {getCurrencyString(props.feePct * props.headlineCents)}
              </b>
              <div className="od-offer-card__fee-divider" />
              Initial Net <b>{getCurrencyString(props.netCents)}</b>
            </div>
          )}
        </div>
        {props.children}
      </div>
    </div>
  );
};

OfferCard.defaultProps = {
  feeLabel: 'Fee',
};

export default OfferCard;
